// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import jobs$ from './jobs'
import { selectedFieldIdNotValidated$ } from 'hfty-map/src/selectors/selectedFieldId'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

export default createSelector(
  [
    jobs$,
    selectedFieldIdNotValidated$,
  ],
  (jobs, selectedFieldId) => {
    return emptyArrayOr(_filter(jobs, (job) => job.field === selectedFieldId))
  }
)
